import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.tsx';
import { registerSW } from './utils/serviceWorker';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

// Register service worker for caching and offline support
registerSW({
  onSuccess: () => {
    console.log('App is cached and ready for offline use');
  },
  onUpdate: () => {
    console.log('New app version available, please refresh');
  },
  onOfflineReady: () => {
    console.log('App is ready to work offline');
  },
});
